import React, {useState,useEffect} from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';

function Component(props) {
  const {  } = useParams();
  const navigate = useNavigate();
  const [data,setdata] = useState(null)
  const [isLoading,setisLoading]=useState(false)


  const fetchData=async(force=false)=>{
    if(isLoading&&!force)return
    setisLoading(true)
    // let result = await fetchWordById(props.token.token,id);
    // if(result.result){
    //     setdata(result.result)
    // }else{
    //     alert('Fetch data error')
    // }
    setisLoading(false)
  }
  useEffect(()=>{
    fetchData();
  },[])


  return (
    <div className='h-full flex-1 bg-[#F2F2F2] p-[16px] flex flex-col gap-[16px]'>
        <div className='text-[#1F4CC8] text-[36px] font-[700]'>歡迎回來</div>
        <div className='text-[#939393] text-[16px]'>我們希望您的專案取得進展！請隨時閱讀最新消息。我們正在根據您的回饋盡最大努力改進產品。</div>
        {isLoading&&<LoadingPage/>}
    </div>
  );
}

export default connect((store)=>{
    return{
      token:store.tokenReducer,
    }
  })(Component)
  